import ptBRLocale from 'date-fns/locale/pt-BR';
import { LocalizationProvider, ptBR } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

type Props = { readonly children: React.ReactNode };

function DateProvider({ children }: Props) {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={ptBRLocale}
      localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      {children}
    </LocalizationProvider>
  );
}

export default DateProvider;
